import { createSelector } from 'reselect'
import { selectCurrentCustomer } from './selectCurrentCustomer'

export const selectCurrentCustomerId = createSelector(
  selectCurrentCustomer,
  customer => (customer ? customer.id : undefined)
)
